export default [
  {
    "login": "ranand345",
    "id": 37949857,
    "node_id": "MDQ6VXNlcjM3OTQ5ODU3",
    "avatar_url": "https://avatars.githubusercontent.com/u/37949857?v=4",
    "gravatar_id": "",
    "url": "https://api.github.com/users/ranand345",
    "html_url": "https://github.com/ranand345",
    "followers_url": "https://api.github.com/users/ranand345/followers",
    "following_url": "https://api.github.com/users/ranand345/following{/other_user}",
    "gists_url": "https://api.github.com/users/ranand345/gists{/gist_id}",
    "starred_url": "https://api.github.com/users/ranand345/starred{/owner}{/repo}",
    "subscriptions_url": "https://api.github.com/users/ranand345/subscriptions",
    "organizations_url": "https://api.github.com/users/ranand345/orgs",
    "repos_url": "https://api.github.com/users/ranand345/repos",
    "events_url": "https://api.github.com/users/ranand345/events{/privacy}",
    "received_events_url": "https://api.github.com/users/ranand345/received_events",
    "type": "User",
    "site_admin": false
  },
  {
    "login": "1aimaneqbal",
    "id": 44510711,
    "node_id": "MDQ6VXNlcjQ0NTEwNzEx",
    "avatar_url": "https://avatars.githubusercontent.com/u/44510711?v=4",
    "gravatar_id": "",
    "url": "https://api.github.com/users/1aimaneqbal",
    "html_url": "https://github.com/1aimaneqbal",
    "followers_url": "https://api.github.com/users/1aimaneqbal/followers",
    "following_url": "https://api.github.com/users/1aimaneqbal/following{/other_user}",
    "gists_url": "https://api.github.com/users/1aimaneqbal/gists{/gist_id}",
    "starred_url": "https://api.github.com/users/1aimaneqbal/starred{/owner}{/repo}",
    "subscriptions_url": "https://api.github.com/users/1aimaneqbal/subscriptions",
    "organizations_url": "https://api.github.com/users/1aimaneqbal/orgs",
    "repos_url": "https://api.github.com/users/1aimaneqbal/repos",
    "events_url": "https://api.github.com/users/1aimaneqbal/events{/privacy}",
    "received_events_url": "https://api.github.com/users/1aimaneqbal/received_events",
    "type": "User",
    "site_admin": false
  },
  {
    "login": "jayyuuuu",
    "id": 70216818,
    "node_id": "MDQ6VXNlcjcwMjE2ODE4",
    "avatar_url": "https://avatars.githubusercontent.com/u/70216818?v=4",
    "gravatar_id": "",
    "url": "https://api.github.com/users/jayyuuuu",
    "html_url": "https://github.com/jayyuuuu",
    "followers_url": "https://api.github.com/users/jayyuuuu/followers",
    "following_url": "https://api.github.com/users/jayyuuuu/following{/other_user}",
    "gists_url": "https://api.github.com/users/jayyuuuu/gists{/gist_id}",
    "starred_url": "https://api.github.com/users/jayyuuuu/starred{/owner}{/repo}",
    "subscriptions_url": "https://api.github.com/users/jayyuuuu/subscriptions",
    "organizations_url": "https://api.github.com/users/jayyuuuu/orgs",
    "repos_url": "https://api.github.com/users/jayyuuuu/repos",
    "events_url": "https://api.github.com/users/jayyuuuu/events{/privacy}",
    "received_events_url": "https://api.github.com/users/jayyuuuu/received_events",
    "type": "User",
    "site_admin": false
  },
  {
    "login": "shubhampatidar1802",
    "id": 69662766,
    "node_id": "MDQ6VXNlcjY5NjYyNzY2",
    "avatar_url": "https://avatars.githubusercontent.com/u/69662766?v=4",
    "gravatar_id": "",
    "url": "https://api.github.com/users/shubhampatidar1802",
    "html_url": "https://github.com/shubhampatidar1802",
    "followers_url": "https://api.github.com/users/shubhampatidar1802/followers",
    "following_url": "https://api.github.com/users/shubhampatidar1802/following{/other_user}",
    "gists_url": "https://api.github.com/users/shubhampatidar1802/gists{/gist_id}",
    "starred_url": "https://api.github.com/users/shubhampatidar1802/starred{/owner}{/repo}",
    "subscriptions_url": "https://api.github.com/users/shubhampatidar1802/subscriptions",
    "organizations_url": "https://api.github.com/users/shubhampatidar1802/orgs",
    "repos_url": "https://api.github.com/users/shubhampatidar1802/repos",
    "events_url": "https://api.github.com/users/shubhampatidar1802/events{/privacy}",
    "received_events_url": "https://api.github.com/users/shubhampatidar1802/received_events",
    "type": "User",
    "site_admin": false
  }
]